import { LruCache } from './lru-cache';
//import entriesReducer from './reducers/entries';

let day = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'];
let mL = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
let mS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
let sLength = 100;


export function addWeightedField(fieldName, weight)
{	
	let weightedField = {
		fieldName,
		weight
	};
	return weightedField;
}

export function addOrderByField(name, direction)
{
	let orderByField = {
		name,
		direction
	};
	return orderByField;
}

export function formatDate(date) {
	let entryDate = new Date(date);
	return `${entryDate.getDate()}/${entryDate.getMonth() + 1}/${entryDate.getFullYear()}`; 
}

export function formatDateFriendly(date) {
	let entryDate = new Date(date);
	return `${day[entryDate.getDay()]}, ${entryDate.getDate()} ${monthName(entryDate.getMonth(), true)} ${entryDate.getFullYear()}`; 
}

// function formatMonthPrepend0(n){
//     return n > 9 ? "" + n: "0" + n;
// }


export function formatMonth(date) {
	let entryDate = new Date(date);
	return monthName(entryDate.getMonth(), false); 
}

export function formatMonthThreeLetters(date) {
	let entryDate = new Date(date);
	return monthName(entryDate.getMonth(), true); 
}

export function nth(d) {
	if(d>3 && d<21) return 'th';
	switch (d % 10) {
		case 1:  return "st";
		case 2:  return "nd";
		case 3:  return "rd";
		default: return "th";
	}
  } 	

function monthName(monthNo, isShort){
	if(isShort){
		return mS[monthNo];
	}
	else{
		return mL[monthNo];
	}
}

export function range(low,hi){
	function rangeRec(low, hi, vals) {
		if(low > hi) return vals;
		vals.push(low);
		return rangeRec(low+1,hi,vals);
	}
	return rangeRec(low,hi,[]);
}

export function createRowsArray(theArray, numItemsPerRow) {
	const rows = [...Array( Math.ceil(theArray.length / numItemsPerRow) )];
	return rows.map( (row, idx) => theArray.slice(idx * numItemsPerRow, idx * numItemsPerRow + numItemsPerRow) );
}

export function chunks(arr, size) {
	if (!Array.isArray(arr)) {
		throw new TypeError('Input should be Array');
	}
  
	if (typeof size !== 'number') {
		throw new TypeError('Size should be a Number');
	}
  
	var result = [];
	for (var i = 0; i < arr.length; i += size) {
		result.push(arr.slice(i, size + i));
	}
  
	return result;
} 

export function getEventDate(entry){
	if(entry.eventDate != null){
		let startDate = new Date(entry.eventDate.from);
		let endDate = new Date(entry.eventDate.to);
		if(startDate.getDate() == endDate.getDate()){
			return `${endDate.getDate()} ${monthName(endDate.getMonth(), true)}`;
		}
		else{
			return `${startDate.getDate()} - ${endDate.getDate()} ${monthName(endDate.getMonth(), true)}`;
		}
	}
	return '';
}
export function getUrl(entry) {

	var isSearchResultsPage = RegExp("/search-results(.*)|/search.html(.*)|/(.*)SearchPageHTMLFile(.*)", "i");

	//var currentUrl = "https://www.non-metallic.com/insights#/";
	var currentUrl = window.location.href;


	if(entry && entry.sys && entry.sys.slug){
		if(entry.sys.contentTypeId === 'pressReleases' || entry.sys.contentTypeId === 'events'){
			return buildNewsEventsUrl(entry);
		}
		if(entry.sys.contentTypeId === 'insights'){
			if (entry.whichWebsiteToDisplayOn && entry.whichWebsiteToDisplayOn.includes("CSWIP") )
			{
					return `${'/microsites/cswip/insights/'}${entry.sys.slug}`;
			}	
			if (entry.whichWebsiteToDisplayOn && entry.whichWebsiteToDisplayOn.includes("TWIDeutschland") )
			{
					return `${'/locations/deutschland/medien-und-events/einblicke/'}${entry.sys.slug}`;
			}

			if (entry.whichWebsiteToDisplayOn && entry.whichWebsiteToDisplayOn.includes("non-metallic") && (isSearchResultsPage.test(currentUrl)))
			{

				return `${'https://www.non-metallic.com/insights/'}${entry.sys.slug}`;	
			}
			
			if (entry.whichWebsiteToDisplayOn && entry.whichWebsiteToDisplayOn.includes("non-metallic") && (!isSearchResultsPage.test(currentUrl)))
			{
				return `${'/microsites/non-metallic/insights/'}${entry.sys.slug}`;
			}


			if (entry.whichWebsiteToDisplayOn && entry.whichWebsiteToDisplayOn.includes("TWIInnovationNetwork") )
			{
					return `${'/innovation-network/media-and-events/insights/'}${entry.sys.slug}`;
			}
			
			

			return `${'/media-and-events/insights/'}${entry.sys.slug}`;
		}
		if(entry.sys.contentTypeId === 'ourStories'){
			return `${'/media-and-events/our-stories/'}${entry.sys.slug}`;
		}
		if(entry.sys.contentTypeId === 'weldasearch'){
			return `${'/technical-knowledge/weldasearch/'}${entry.sys.slug}`;
		}
		if(entry.sys.contentTypeId === 'publishedPapers')
		{
			return `${'/technical-knowledge/published-papers/'}${entry.sys.slug}`;
		}
		if(entry.sys.contentTypeId === 'jips')
		{
			return `${'/what-we-do/research-and-technology/research-programmes/joint-industry-projects/'}${entry.sys.slug}`;
		}
		if(entry.sys.contentTypeId === 'cswipSchemes' && entry.whichWebsiteToDisplayOn.list.includes('CSWIP'))
		{
			return `${'/microsites/cswip/certification/'}${entry.sys.slug}`;
		}

		if(entry.sys.contentTypeId === 'cswipSchemes' && entry.whichWebsiteToDisplayOn.list.includes('TWICertification'))
		{
			return `${'/microsites/twi-certification/certifications/'}${entry.sys.slug}`;
		}


		if(entry.sys.contentTypeId === 'publicFundedProjects')
		{
			return `${'/what-we-do/research-and-technology/research-programmes/public-funded-projects/'}${entry.sys.slug}`;
		}

		if (entry && entry.sys && entry.sys.uri && entry.sys.uri.startsWith('/what-we-do/research-and-technology/research-programmes/'))
		{
			return `${entry.sys.uri}`;
		}

		if(entry.sys.contentTypeId === 'staffProfiles')
		{
			return `${'/careers/our-people/'}${entry.sys.slug}`;
		}

		// if(entry.sys.contentTypeId === 'videos')
		// {
		// 	return `${'/what-we-do/innovation-network/showcase/'}${entry.sys.slug}`;
		// }

		//var preString = "microsites/non-metallic/insights.aspx";

		var preString = window.location.pathname;

		preString = preString.replace("/home.aspx", "");
	
		if (preString.includes(".aspx"))
		{
			preString = preString.substring(0, preString.lastIndexOf(".aspx"));
		}
	
		//preString += "/";

		return `${preString}/${entry.sys.slug}`;
	}

	if(entry && entry.sys && entry.sys.uri){
		return entry.sys.uri;
	}
	return '';
}


function buildNewsEventsUrl(entry){
	let date = entry.eventDate ? entry.eventDate.from : entry.publishDate;
	let entryDate = new Date(date);


	var preString = window.location.pathname; 

	//preString = "media-and-events/events-diary/all-events#/";
	//preString = "media-and-events/events-diary/all-events.aspx#/";
	//preString = "media-and-events/events-diary/all-events.aspx";

	//preString = "/media-and-events/press-releases#/";
	//preString = 	"/media-and-events/press-releases/home.aspx#/";
	//preString = 	"/media-and-events/press-releases/home.aspx";

	//preString = 	"/portal/events/bae.aspx#/";
	//preString = 	"/portal/events/bae#/";
	//preString = 	"/portal/events/bae.aspx";

	//preString = preString.replace(/\/?(all-events|home)?(.aspx)?#\/?/, "");


	preString = preString.replace("/home.aspx", "");

	if (preString.includes(".aspx"))
	{
		preString = preString.substring(0, preString.lastIndexOf(".aspx"));
	}

	if (preString.endsWith('#/'))
	{
		preString = preString.replace("#/", "");
	}

	preString = preString.replace("/all-events", "");



	var isSearchResultsPage = RegExp("/search-results(.*)|/search.html(.*)|/(.*)SearchPageHTMLFile(.*)", "i");
	var isNSIRCSearchResultsPage = RegExp("/nsirc/search-results(.*)|/NSIRCSearchPageHTMLFile.html(.*)", "i");
	var isCSWIPSearchResultsPage = RegExp("/cswip/search-results(.*)|/CSWIPSearchPageHTMLFile.html(.*)", "i");
	var isTWIINSearchResultsPage = RegExp("/innovation-network/search-results(.*)|/TWIInnovationNetworkSearchPageHTMLFile(.*)", "i");

	var currentUrl = window.location.href;


	//window.location.href = https://www.twi-global.com/media-and-events/press-releases#/

	//https://www.twi-global.com/media-and-events/press-releases#/



	//var currentUrl = 	"https://www.twi-global.com/media-and-events/press-releases#/";
	//var currentUrl = 	"https://www.twi-global.com/media-and-events/media-and-events/events-diary/all-events#/";
	

	//var currentUrl = "https://preview-twi.cloud.contensis.com/nsirc/search-results.aspx#/?term=phd";

	//tests
	//var currentUrl = "https://www.twi-global.com.com/media-and-events/events-diary/all-events#/";

	//var currentUrl = "https://www.twi-innovation-network.com/media-and-events/events-diary/all-events#/";

	//var currentUrl = "https://preview-twi.cloud.contensis.com/microsites/twi-innovation-network/media-and-events/events-diary/all-events.aspx#/";

	//var currentUrl = "https://preview-twi.cloud.contensis.com/media-and-events/events-diary/all-events.aspx#/";

	//var currentUrl = "https://preview-twi-dev.cloud.contensis.com/media-and-events/events-diary/all-events.aspx#/";

	//var currentUrl = "https://preview-twi.cloud.contensis.com/microsites/cswip/press-releases.aspx#/";

	//var currentUrl = "https://www.cswip.com/press-releases.aspx#/";

	// currentUrl = "https://preview-twi.cloud.contensis.com/microsites/NSIRC/our-research/phd-theses.aspx#/";



	if(entry.sys.contentTypeId == 'pressReleases' && isSearchResultsPage.test(currentUrl)) {

		preString = '/media-and-events/press-releases/';

		if(entry.whichWebsiteToDisplayOn != null) {

			if (isNSIRCSearchResultsPage.test(currentUrl)) {

				if(entry.whichWebsiteToDisplayOn.includes("NSIRC_news"))
				{
					preString = '/nsirc/news/';
				}
		
				if(entry.whichWebsiteToDisplayOn.includes("NSIRC_publications"))
				{
					preString = '/nsirc/our-research/phd-publications/';
				}
		
				if(entry.whichWebsiteToDisplayOn.includes("NSIRC_theses"))
				{
					preString = '/nsirc/our-research/phd-theses/';
				}
		
				if(entry.whichWebsiteToDisplayOn.includes("NSIRC_dissertations"))
				{
					preString = '/nsirc/our-research/msc-dissertations/';
				}
		
				if(entry.whichWebsiteToDisplayOn.includes("NSIRC_students"))
				{
					preString = '/nsirc/our-research/student-profiles/';
				}
		
				if(entry.whichWebsiteToDisplayOn.includes("NSIRC_insights"))
				{
					preString = '/nsirc/media-and-events/insights/';
				}


			}

			if(isCSWIPSearchResultsPage.test(currentUrl) && entry.whichWebsiteToDisplayOn.includes("CSWIP"))
			{
				preString = '/microsites/cswip/press-releases/';
			}

			if(isTWIINSearchResultsPage.test(currentUrl) && entry.whichWebsiteToDisplayOn.includes("TWIInnovationNetwork"))
			{
				preString = '/innovation-network/media-and-events/press-releases/';
			}

			

		}




		return `${preString}${entryDate.getFullYear()}/${entry.sys.slug}`;


	} 

	if (entry.sys.contentTypeId == 'events')
	{
		// no date for events
		return `${preString}/${entry.sys.slug}`;
	}


	//for press releases
	return `${preString}/${entryDate.getFullYear()}/${entry.sys.slug}`;
}


export function getPublishDate(entry) {
	if (entry && entry.sys && entry.sys.contentTypeId == 'weldasearch'){
		return entry.year;
	}

	if (entry && entry.publishDate) {
		return formatDateFriendly(entry.publishDate);
	}

	if (entry && entry.sys && entry.sys.metadata && entry.sys.metadata.pageDate && entry.sys.metadata.pageDate != '1900-01-01T12:00:00Z') {
		return formatDateFriendly(entry.sys.metadata.pageDate);
	}

	if (entry && entry.sys && entry.sys.version && entry.sys.version.published) {
		return formatDateFriendly(entry.sys.version.published);
	}
	if (entry && entry.sys && entry.sys.version && entry.sys.version.modified) {
		return formatDateFriendly(entry.sys.version.modified);
	}
	return null;
}

const entityToChar = str => { 
	const textarea = document.createElement('textarea'); 
	textarea.innerHTML = str; 
	return textarea.value; 
  };

export function getDescText(entry){
	var descText = "";
	if(entry && entry.searchContent){
		descText = entry.searchContent;
	}
	if(entry && entry.summary){
		descText = entry.summary;
	}
	if(entry && entry.description != null){
		descText = entry.description && !Array.isArray(entry.description) ? entry.description : entry.description[0].toString() ;
	}

	if(entry.sys.contentTypeId == "staffProfiles" && entry.profile != null){
		descText = entry.profile;
	}

	if(entry.sys.contentTypeId == "showcase" && entry.videoDescription != null){
		descText = entry.videoDescription;
	}

	if(entry.sys.contentTypeId == "cswipSchemes" && entry.schemeDescription != null)
	{
		descText = entry.schemeDescription;
	}

	//remove html tags
	descText = descText.replace(/<[^>]+>/g, '');

	//remove double spaces
	descText = descText.replace(/\s\s+/g, ' ');

	descText = entityToChar(descText);



	return descText = descText && descText.length > sLength ? descText.substring(0, sLength).trim() + '...' : descText;

}

export function getCSWIPTitle(entry) {
	var title = "no title";

	if (entry.sys.contentTypeId == "cswipSchemes" && entry.schemeName != null)
	{
		title = entry.schemeName;
	}

	if (entry.title != null)
	{
		title = entry.title;
	}

	return title;

	
	
}


class Cache {

	cache = new LruCache();

	getCachedUrl(entry) {


		return this.request(`[URL] ${entry.sys.id}`, getUrl(entry));
	}

	request(key, execute) {
		if (!this.cache.get(key)) {
			let promise = execute;
			this.cache.set(key, promise);
		}
		return this.cache.get(key);
	}
}

export const cacheFunc = new Cache();


/* sw */

//published papers dates
// export function getPageDateShort(entry) 
// {
// 	return formatDateFriendly(entry.pageDate);
// }

export function getPageYear(entry){
	let entryDate = new Date(entry.sys.metadata.pageDate);

	if (entry.sys.contentTypeId == 'publishedPapers')
	{
		entryDate = new Date(entry.pageDate);
	}

	if (entry.sys.contentTypeId == 'cswipSchemes')
	{
		entryDate = new Date(entry.schemePublishedDate);
	}

	return `${entryDate.getFullYear()}`; 
}

export function getPageDateShort(entry) {



	let entryDate = entry.sys.metadata.pageDate != null ? new Date(entry.sys.metadata.pageDate) : "";

	if (entry.sys.contentTypeId == 'publishedPapers')
	{
		entryDate = new Date(entry.pageDate);
	}

	entryDate = entryDate == "" ? entryDate = new Date(entry.sys.version.published) : entryDate;

	var m = entryDate.getUTCMonth();
	var y = entryDate.getUTCFullYear();

	return `${monthName(m, true)} ${y}`; 
}

export function getDateAnnouncedShort(entry) {

	let dateAnnounced = new Date(entry.dateAnnounced);

	
	return `${monthName(dateAnnounced.getMonth(), true)} ${dateAnnounced.getFullYear()}`; 
}